import { apiFetchCore, apiNoContentTypeFetchCore } from "./apiFetchCore";

let worker: Worker | null = null;

if (typeof window !== "undefined" && typeof Worker !== "undefined") {
  try {
    worker = new Worker("/loading.worker.js", { type: "module" });

    worker.onmessage = (e) => {
      if (typeof CustomEvent !== "undefined") {
        const event = new CustomEvent("toggle-loading", { detail: e.data });
        window.dispatchEvent(event);
      }
    };
  } catch (e) {
    console.log("Worker init skipped");
  }
}

export interface CustomFetchOptions extends RequestInit {
  hideGlobalLoader?: boolean; // true を渡すとグローバルローダーを表示しない
}

// 長時間処理では複数回のポーリング通信を1つのローディング表示として扱う。
// worker側でリクエスト数を数えるため、他画面の通信中でも安全に併用できる。
export function showGlobalLoader(): void {
  worker?.postMessage({ type: "start" });
}

export function hideGlobalLoader(): void {
  worker?.postMessage({ type: "end" });
}

export async function apiFetch<T>(url: string, options: CustomFetchOptions = {}): Promise<T> {
  const { hideGlobalLoader, ...fetchOptions } = options;
  const shouldShowLoader = !hideGlobalLoader; // hideGlobalLoader が true でなければ表示

  if (worker && shouldShowLoader) {
    worker.postMessage({ type: "start" });
  }

  try {
    return await apiFetchCore<T>(url, fetchOptions);
  } finally {
    if (worker && shouldShowLoader) {
      worker.postMessage({ type: "end" });
    }
  }
}

export async function apiNoContentTypeFetch<T>(url: string, options: CustomFetchOptions = {}): Promise<T> {
  const { hideGlobalLoader, ...fetchOptions } = options;
  const shouldShowLoader = !hideGlobalLoader;

  if (worker && shouldShowLoader) {
    worker.postMessage({ type: "start" });
  }

  try {
    return await apiNoContentTypeFetchCore<T>(url, fetchOptions);
  } finally {
    if (worker && shouldShowLoader) {
      worker.postMessage({ type: "end" });
    }
  }
}
